import stripe from './stripe_logo.png';
import logo from './logo.webp';
import review from './review.webp';
import coomingSoon from './commingsoon.webp';
const images = {
    Stripe: stripe,
    Logo: logo,
    Review: review,
    CoomingSoon :coomingSoon
}

export default images